export default "__VITE_ASSET__CYYZo3qu__"